// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { ProviderServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Provider';
import { ERR_CAN_PROVIDER_SVC, SUC_CAN_PROVIDER_SVC } from '../../../../utils/strings';

export const useCancelProviderServiceRequest = () => {
  const { submit } = useExerciseSubmission(
    ProviderServiceRequest.ProviderServiceRequest_Cancel,
    SUC_CAN_PROVIDER_SVC,
    ERR_CAN_PROVIDER_SVC,
  );
  return submit;
};
